import { useEffect, useState } from "react";
import { C, GlassCard, Sparkline, Skeleton, Badge } from "@coremonit/design-system";
import { StepHeader } from "./common";
import type { WizardData } from "../wizardStore";

interface Props { data: WizardData; update: (p: Partial<WizardData>) => void }

export function Step7Baseline({ data, update }: Props) {
  const [progress, setProgress] = useState(data.baseline ? 100 : 0);
  const [samples, setSamples] = useState<number[]>([]);

  useEffect(() => {
    if (data.baseline) return;
    let p = 0;
    const seq: number[] = [];
    const t = setInterval(() => {
      p += 5 + Math.random() * 10;
      seq.push(80 + Math.random() * 30);
      setSamples([...seq]);
      if (p >= 100) {
        p = 100;
        setProgress(100);
        clearInterval(t);
        update({
          baseline: {
            window: "5m",
            baseline: {
              cpuPct: 42.1, memPct: 58.4, latencyP95Ms: 210, errorRatePct: 0.2,
              requestsPerMin: 620, saturationPct: 61,
            },
          },
        });
      } else {
        setProgress(Math.floor(p));
      }
    }, 220);
    return () => clearInterval(t);
  }, []); // eslint-disable-line

  const b = data.baseline;
  return (
    <div>
      <StepHeader title="Collecting baseline" description="We're capturing a 5-minute reference window of key signals so alerts can be tuned against normal behavior instead of arbitrary thresholds." />
      <GlassCard style={{ padding: 18, marginBottom: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <div style={{ color: C.textSub, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4 }}>Sampling</div>
          <Badge color={progress >= 100 ? "green" : "blue"}>{progress}%</Badge>
        </div>
        <div style={{ width: "100%", height: 6, background: C.surfaceMid, borderRadius: 6, overflow: "hidden", marginBottom: 12 }}>
          <div style={{ width: `${progress}%`, height: "100%", background: `linear-gradient(90deg, ${C.blue}, ${C.cyan})`, boxShadow: `0 0 12px rgba(45,127,249,0.4)`, transition: "width 0.3s ease" }} />
        </div>
        <Sparkline data={samples.length ? samples : [0, 0]} color={C.blue} width={520} height={44} />
      </GlassCard>
      {b && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 10 }}>
          {Object.entries(b.baseline).map(([k, v]) => (
            <GlassCard key={k} style={{ padding: 12 }}>
              <div style={{ color: C.textMuted, fontSize: 9, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 700 }}>{k}</div>
              <div style={{ color: C.text, fontSize: 16, fontWeight: 700, marginTop: 4 }}>{typeof v === "number" ? v.toFixed(v < 10 ? 2 : 1) : String(v)}</div>
            </GlassCard>
          ))}
        </div>
      )}
    </div>
  );
}
